import { useState } from "react";
import { COMICS } from "@/mocks/comics";
import ComicCard from "@/components/feature/ComicCard";
import ShareDialog from "@/components/feature/ShareDialog";
import SiteLayout from "@/components/feature/SiteLayout";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryShortcuts from "@/pages/home/components/CategoryShortcuts";
import LatestGrid from "@/pages/home/components/LatestGrid";
import HotRanking from "@/pages/home/components/HotRanking";
import SiteIntro from "@/pages/home/components/SiteIntro";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function Home() {
  const [shareOpen, setShareOpen] = useState(false);

  usePageMeta(
    "禁漫天堂 - 最新动漫漫画资源下载平台",
    "禁漫天堂为用户提供丰富的动漫漫画资源，涵盖多类别作品，支持快速查找与下载，满足动漫爱好者的阅读需求。",
    "禁漫天堂,动漫下载,漫画资源,漫画下载,免费漫画,动漫平台,漫画合集",
  );

  const spotlight = COMICS.filter((c) => c.score >= 9).slice(0, 3);

  return (
    <SiteLayout>
      <HeroCarousel />

      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_320px] gap-6 md:gap-8">
          <div className="min-w-0 flex flex-col gap-10 md:gap-14">
            <CategoryShortcuts />
            <LatestGrid comics={COMICS} />
          </div>
          <div className="lg:sticky lg:top-24 h-fit flex flex-col gap-4">
            <HotRanking onShare={() => setShareOpen(true)} />

            <div className="rounded-lg border hairline bg-background-900/70 p-4">
              <h2 className="text-sm font-medium text-foreground-50 flex items-center gap-2">
                <span className="w-6 h-6 rounded flex items-center justify-center bg-secondary-900/70 text-secondary-200">
                  <i className="ri-star-smile-line text-sm" />
                </span>
                编辑精选
              </h2>
              <ul className="mt-3 space-y-3">
                {spotlight.map((comic) => (
                  <li key={comic.id} className="flex items-center gap-3">
                    <span className="w-11 h-14 rounded-md overflow-hidden shrink-0 bg-background-800">
                      <img
                        src={comic.cover}
                        alt={`《${comic.title}》封面`}
                        className="w-full h-full object-cover object-top"
                      />
                    </span>
                    <span className="min-w-0 flex-1">
                      <a
                        href={`${__BASE_PATH__}detail/${comic.id}`.replace(/\/{2,}/g, "/")}
                        className="block text-[13px] text-foreground-100 truncate hover:text-accent-300 transition-colors"
                      >
                        {comic.title}
                      </a>
                      <span className="mt-1 block text-[11px] text-foreground-500 truncate">{comic.tagline}</span>
                      <span className="mt-1 block text-[10px] font-label text-accent-400">评分 {comic.score.toFixed(1)}</span>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-lg border border-accent-500/30 bg-accent-500/10 p-4">
              <p className="text-[11px] font-label tracking-[0.18em] text-accent-300">DEMO NOTICE</p>
              <p className="mt-2 text-xs leading-6 text-foreground-200">
                当前站点使用本地演示数据，下载与分享均为交互演示，不提供真实文件传输。
              </p>
            </div>
          </div>
        </div>

        <div className="h-10 md:h-14" />
        <SiteIntro />
        <div className="h-4" />
        <section aria-label="为你准备的下一步" className="w-full">
          <div className="rounded-lg border hairline bg-gradient-to-r from-primary-900/70 via-background-900/70 to-secondary-900/60 px-5 md:px-8 py-6 md:py-8 flex flex-col md:flex-row md:items-center gap-5">
            <div className="min-w-0 flex-1">
              <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-50">
                不知道先看哪本？按题材筛一遍就有答案
              </h2>
              <p className="mt-2 text-xs md:text-sm text-foreground-300">
                分类页支持状态、地区、年份与排序组合筛选，找不到时可以一键重置条件。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <a
                href={`${__BASE_PATH__}category/fantasy`.replace(/\/{2,}/g, "/")}
                className="h-10 px-4 rounded-md bg-accent-500 text-background-950 text-sm font-medium flex items-center gap-1.5 hover:bg-accent-400 transition-colors whitespace-nowrap"
              >
                奇幻分类
              </a>
              <a
                href={`${__BASE_PATH__}search`.replace(/\/{2,}/g, "/")}
                className="h-10 px-4 rounded-md border border-background-600/70 text-sm text-foreground-100 flex items-center gap-1.5 hover:border-accent-500/60 hover:text-accent-300 transition-colors whitespace-nowrap"
              >
                关键词搜索
              </a>
            </div>
          </div>
        </section>
      </div>

      <ShareDialog open={shareOpen} onClose={() => setShareOpen(false)} />
    </SiteLayout>
  );
}